import React from 'react';
import {Head} from 'react-static';
const {SITE_URL} = process.env;

export default function PageMeta({
  url = `${SITE_URL}masterclass/`,
  ogImage = 'https://cdn.foodrevolution.org/tt2/og/tt2-evergreen-opengraph-landing-1200x1200-v20220804.png',
  title = 'Join the free Tackling Type 2 Masterclass with Brenda Davis, RD, and Ocean Robbins from Food Revolution Network',
  description = 'Watch the Tackling Type 2 Masterclass to learn the 4 BIG Type 2 diabetes MYTHS and 10 recent BREAKTHROUGHS.'
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:site" content="@afoodrevolution" />
      <meta property="twitter:image" content={ogImage} />
      <meta property="fb:app_id" content="1685199371775570" />
      <meta property="og:site_name" content="Tackling Type 2 Masterclass" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
